import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <summary>
  {{i18n "search.advanced.title"}}
</summary>
<div class="search-advanced-filters">
  <div class="search-advanced-options">
    <PluginOutlet
      @name="advanced-search-options-above"
      @connectorTagName="div"
      @outletArgs={{hash
        searchedTerms=this.searchedTerms
        onChangeSearchedTermField=this.onChangeSearchedTermField
      }}
    />

    <div class="control-group advanced-search-category">
      <label class="control-label">{{i18n
          "search.advanced.in_category.label"
        }}</label>
      <div class="controls">
        <SearchAdvancedCategoryChooser
          @id="search-in-category"
          @value={{this.searchedTerms.category.id}}
          @onChange={{action "onChangeSearchTermForCategory"}}
        />
      </div>
    </div>

    {{#if this.siteSettings.tagging_enabled}}
      <div class="control-group advanced-search-tags">
        <label class="control-label">{{i18n
            "search.advanced.with_tags.label"
          }}</label>
        <div class="controls">
          <TagChooser
            @id="search-with-tags"
            @tags={{this.searchedTerms.tags}}
            @everyTag={{true}}
            @unlimitedTagCount={{true}}
            @onChange={{action "onChangeSearchTermForTags"}}
            @options={{hash
              allowAny=false
              headerAriaLabel=(i18n "search.advanced.with_tags.aria_label")
            }}
          />
          {{#if this.showAllTagsCheckbox}}
            <section class="field">
              <label>
                <Input
                  @type="checkbox"
                  class="all-tags"
                  @checked={{this.searchedTerms.special.all_tags}}
                  {{on
                    "click"
                    (action
                      "onChangeSearchTermForAllTags" value="target.checked"
                    )
                  }}
                />
                {{i18n "search.advanced.filters.all_tags"}}
              </label>
            </section>
          {{/if}}
        </div>
      </div>
    {{/if}}

    <div class="control-group advanced-search-topics-posts">
      <div class="controls">
        <fieldset class="grouped-control">
          <legend class="grouped-control-label">{{i18n
              "search.advanced.filters.label"
            }}</legend>

          {{#if this.currentUser}}
            <div class="grouped-control-field">
              <Input
                id="matching-title-only"
                @type="checkbox"
                class="in-title"
                @checked={{this.searchedTerms.special.in.title}}
                {{on
                  "click"
                  (action
                    "onChangeSearchTermForSpecialInTitle" value="target.checked"
                  )
                }}
              />
              <label class="checkbox-label" for="matching-title-only">
                {{i18n "search.advanced.filters.title"}}
              </label>
            </div>

            <div class="grouped-control-field">
              <Input
                id="matching-liked"
                @type="checkbox"
                class="in-likes"
                @checked={{this.searchedTerms.special.in.likes}}
                {{on
                  "click"
                  (action
                    "onChangeSearchTermForSpecialInLikes" value="target.checked"
                  )
                }}
              />
              <label class="checkbox-label" for="matching-liked">{{i18n
                  "search.advanced.filters.likes"
                }}</label>
            </div>

            <div class="grouped-control-field">
              <Input
                id="matching-in-messages"
                @type="checkbox"
                class="in-private"
                @checked={{this.searchedTerms.special.in.messages}}
                {{on
                  "click"
                  (action
                    "onChangeSearchTermForSpecialInMessages"
                    value="target.checked"
                  )
                }}
              />
              <label class="checkbox-label" for="matching-in-messages">{{i18n
                  "search.advanced.filters.private"
                }}</label>
            </div>

            <div class="grouped-control-field">
              <Input
                id="matching-seen"
                @type="checkbox"
                class="in-seen"
                @checked={{this.searchedTerms.special.in.seen}}
                {{on
                  "click"
                  (action
                    "onChangeSearchTermForSpecialInSeen" value="target.checked"
                  )
                }}
              />
              <label class="checkbox-label" for="matching-seen">{{i18n
                  "search.advanced.filters.seen"
                }}</label>
            </div>
          {{/if}}

          <ComboBox
            @id="in"
            @valueProperty="value"
            @content={{this.inOptions}}
            @value={{this.searchedTerms.in}}
            @onChange={{action "onChangeSearchTermForIn"}}
            @options={{hash none="user.locale.any" clearable=true}}
          />
        </fieldset>
      </div>
    </div>

    <div class="control-group advanced-search-topic-status">
      <label class="control-label">{{i18n
          "search.advanced.statuses.label"
        }}</label>
      <div class="controls">
        <ComboBox
          @id="search-status-options"
          @valueProperty="value"
          @content={{this.statusOptions}}
          @value={{this.searchedTerms.status}}
          @onChange={{action "onChangeSearchTermForStatus"}}
          @options={{hash
            none="user.locale.any"
            headerAriaLabel=(i18n "search.advanced.statuses.label")
            clearable=true
          }}
        />
      </div>
    </div>

    <div class="control-group advanced-search-posted-by">
      <label class="control-label">
        {{i18n "search.advanced.posted_by.label"}}
      </label>
      <div class="controls">
        <UserChooser
          @id="search-posted-by"
          @value={{this.searchedTerms.username}}
          @onChange={{action "onChangeSearchTermForUsername"}}
          @options={{hash
            headerAriaLabel=(i18n "search.advanced.posted_by.aria_label")
            maximum=1
            excludeCurrentUser=false
          }}
        />
      </div>
    </div>

    <div class="control-group advanced-search-posted-date">
      <label class="control-label">{{i18n
          "search.advanced.post.time.label"
        }}</label>
      <div class="controls inline-form full-width">
        <ComboBox
          @id="postTime"
          @valueProperty="value"
          @content={{this.postTimeOptions}}
          @value={{this.searchedTerms.time.when}}
          @onChange={{action "onChangeWhenTime"}}
          @options={{hash
            headerAriaLabel=(i18n "search.advanced.post.time.aria_label")
          }}
        />
        <DateInput
          @date={{this.searchedTerms.time.days}}
          @onChange={{action "onChangeWhenDate"}}
          @inputId="search-post-date"
        />
      </div>
    </div>

    <PluginOutlet
      @name="advanced-search-options-below"
      @connectorTagName="div"
      @outletArgs={{hash
        searchedTerms=this.searchedTerms
        onChangeSearchedTermField=this.onChangeSearchedTermField
      }}
    />
  </div>

  <details class="search-advanced-additional-options">
    <summary>
      {{i18n "search.advanced.additional_options.label"}}
    </summary>
    <div class="count-group control-group">
      {{! TODO: Using a label here fails no-nested-interactive lint rule }}
      <span class="control-label">{{i18n
          "search.advanced.post.count.label"
        }}</span>
      <div class="controls">
        <Input
          @type="number"
          @value={{readonly this.searchedTerms.min_posts}}
          class="input-small"
          id="search-min-post-count"
          placeholder={{i18n "search.advanced.post.min.placeholder"}}
          aria-label={{i18n "search.advanced.post.min.aria_label"}}
          {{on "input" (with-event-value this.onChangeSearchTermMinPostCount)}}
        />
        {{d-icon "arrows-alt-h"}}
        <Input
          @type="number"
          @value={{readonly this.searchedTerms.max_posts}}
          class="input-small"
          id="search-max-post-count"
          placeholder={{i18n "search.advanced.post.max.placeholder"}}
          aria-label={{i18n "search.advanced.post.max.aria_label"}}
          {{on "input" (with-event-value this.onChangeSearchTermMaxPostCount)}}
        />
      </div>
    </div>

    <div class="count-group control-group">
      {{! TODO: Using a label here fails no-nested-interactive lint rule }}
      <span class="control-label">{{i18n "search.advanced.views.label"}}</span>
      <div class="controls">
        <Input
          @type="number"
          @value={{readonly this.searchedTerms.min_views}}
          class="input-small"
          id="search-min-views"
          placeholder={{i18n "search.advanced.min_views.placeholder"}}
          aria-label={{i18n "search.advanced.min_views.aria_label"}}
          {{on "input" (with-event-value this.onChangeSearchTermMinViews)}}
        />
        {{d-icon "arrows-alt-h"}}
        <Input
          @type="number"
          @value={{readonly this.searchedTerms.max_views}}
          class="input-small"
          id="search-max-views"
          placeholder={{i18n "search.advanced.max_views.placeholder"}}
          aria-label={{i18n "search.advanced.max_views.aria_label"}}
          {{on "input" (with-event-value this.onChangeSearchTermMaxViews)}}
        />
      </div>
    </div>
  </details>

  {{#if this.site.mobileView}}
    <div class="second-search-button">
      <DButton
        @action={{this.search}}
        @icon="search"
        @label="search.search_button"
        @ariaLabel="search.search_button"
        @disabled={{this.searchButtonDisabled}}
        class="btn-primary search-cta"
      />
    </div>
  {{/if}}
</div>
*/
{
  "id": "RuJEtA8L",
  "block": "[[[10,\"summary\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"search.advanced.title\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"search-advanced-filters\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"search-advanced-options\"],[12],[1,\"\\n    \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"advanced-search-options-above\",\"div\",[28,[37,2],null,[[\"searchedTerms\",\"onChangeSearchedTermField\"],[[30,0,[\"searchedTerms\"]],[30,0,[\"onChangeSearchedTermField\"]]]]]]],null],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-group advanced-search-category\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,0],[\"search.advanced.in_category.label\"],null]],[13],[1,\"\\n      \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@id\",\"@value\",\"@onChange\"],[\"search-in-category\",[30,0,[\"searchedTerms\",\"category\",\"id\"]],[28,[37,4],[[30,0],\"onChangeSearchTermForCategory\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"siteSettings\",\"tagging_enabled\"]],[[[1,\"      \"],[10,0],[14,0,\"control-group advanced-search-tags\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,0],[\"search.advanced.with_tags.label\"],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n          \"],[8,[39,6],null,[[\"@id\",\"@tags\",\"@everyTag\",\"@unlimitedTagCount\",\"@onChange\",\"@options\"],[\"search-with-tags\",[30,0,[\"searchedTerms\",\"tags\"]],true,true,[28,[37,4],[[30,0],\"onChangeSearchTermForTags\"],null],[28,[37,2],null,[[\"allowAny\",\"headerAriaLabel\"],[false,[28,[37,0],[\"search.advanced.with_tags.aria_label\"],null]]]]]],null],[1,\"\\n\"],[41,[30,0,[\"showAllTagsCheckbox\"]],[[[1,\"            \"],[10,\"section\"],[14,0,\"field\"],[12],[1,\"\\n              \"],[10,\"label\"],[12],[1,\"\\n                \"],[8,[39,7],[[24,0,\"all-tags\"],[4,[38,8],[\"click\",[28,[37,4],[[30,0],\"onChangeSearchTermForAllTags\"],[[\"value\"],[\"target.checked\"]]]],null]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"searchedTerms\",\"special\",\"all_tags\"]]]],null],[1,\"\\n                \"],[1,[28,[35,0],[\"search.advanced.filters.all_tags\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,0],[14,0,\"control-group advanced-search-topics-posts\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n        \"],[10,\"fieldset\"],[14,0,\"grouped-control\"],[12],[1,\"\\n          \"],[10,\"legend\"],[14,0,\"grouped-control-label\"],[12],[1,[28,[35,0],[\"search.advanced.filters.label\"],null]],[13],[1,\"\\n\\n\"],[41,[30,0,[\"currentUser\"]],[[[1,\"            \"],[10,0],[14,0,\"grouped-control-field\"],[12],[1,\"\\n              \"],[8,[39,7],[[24,1,\"matching-title-only\"],[24,0,\"in-title\"],[4,[38,8],[\"click\",[28,[37,4],[[30,0],\"onChangeSearchTermForSpecialInTitle\"],[[\"value\"],[\"target.checked\"]]]],null]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"searchedTerms\",\"special\",\"in\",\"title\"]]]],null],[1,\"\\n              \"],[10,\"label\"],[14,0,\"checkbox-label\"],[14,\"for\",\"matching-title-only\"],[12],[1,\"\\n                \"],[1,[28,[35,0],[\"search.advanced.filters.title\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"grouped-control-field\"],[12],[1,\"\\n              \"],[8,[39,7],[[24,1,\"matching-liked\"],[24,0,\"in-likes\"],[4,[38,8],[\"click\",[28,[37,4],[[30,0],\"onChangeSearchTermForSpecialInLikes\"],[[\"value\"],[\"target.checked\"]]]],null]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"searchedTerms\",\"special\",\"in\",\"likes\"]]]],null],[1,\"\\n              \"],[10,\"label\"],[14,0,\"checkbox-label\"],[14,\"for\",\"matching-liked\"],[12],[1,[28,[35,0],[\"search.advanced.filters.likes\"],null]],[13],[1,\"\\n            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"grouped-control-field\"],[12],[1,\"\\n              \"],[8,[39,7],[[24,1,\"matching-in-messages\"],[24,0,\"in-private\"],[4,[38,8],[\"click\",[28,[37,4],[[30,0],\"onChangeSearchTermForSpecialInMessages\"],[[\"value\"],[\"target.checked\"]]]],null]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"searchedTerms\",\"special\",\"in\",\"messages\"]]]],null],[1,\"\\n              \"],[10,\"label\"],[14,0,\"checkbox-label\"],[14,\"for\",\"matching-in-messages\"],[12],[1,[28,[35,0],[\"search.advanced.filters.private\"],null]],[13],[1,\"\\n            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"grouped-control-field\"],[12],[1,\"\\n              \"],[8,[39,7],[[24,1,\"matching-seen\"],[24,0,\"in-seen\"],[4,[38,8],[\"click\",[28,[37,4],[[30,0],\"onChangeSearchTermForSpecialInSeen\"],[[\"value\"],[\"target.checked\"]]]],null]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"searchedTerms\",\"special\",\"in\",\"seen\"]]]],null],[1,\"\\n              \"],[10,\"label\"],[14,0,\"checkbox-label\"],[14,\"for\",\"matching-seen\"],[12],[1,[28,[35,0],[\"search.advanced.filters.seen\"],null]],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[8,[39,9],null,[[\"@id\",\"@valueProperty\",\"@content\",\"@value\",\"@onChange\",\"@options\"],[\"in\",\"value\",[30,0,[\"inOptions\"]],[30,0,[\"searchedTerms\",\"in\"]],[28,[37,4],[[30,0],\"onChangeSearchTermForIn\"],null],[28,[37,2],null,[[\"none\",\"clearable\"],[\"user.locale.any\",true]]]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-group advanced-search-topic-status\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,0],[\"search.advanced.statuses.label\"],null]],[13],[1,\"\\n      \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n        \"],[8,[39,9],null,[[\"@id\",\"@valueProperty\",\"@content\",\"@value\",\"@onChange\",\"@options\"],[\"search-status-options\",\"value\",[30,0,[\"statusOptions\"]],[30,0,[\"searchedTerms\",\"status\"]],[28,[37,4],[[30,0],\"onChangeSearchTermForStatus\"],null],[28,[37,2],null,[[\"none\",\"headerAriaLabel\",\"clearable\"],[\"user.locale.any\",[28,[37,0],[\"search.advanced.statuses.label\"],null],true]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-group advanced-search-posted-by\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"search.advanced.posted_by.label\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n        \"],[8,[39,10],null,[[\"@id\",\"@value\",\"@onChange\",\"@options\"],[\"search-posted-by\",[30,0,[\"searchedTerms\",\"username\"]],[28,[37,4],[[30,0],\"onChangeSearchTermForUsername\"],null],[28,[37,2],null,[[\"headerAriaLabel\",\"maximum\",\"excludeCurrentUser\"],[[28,[37,0],[\"search.advanced.posted_by.aria_label\"],null],1,false]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-group advanced-search-posted-date\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,0],[\"search.advanced.post.time.label\"],null]],[13],[1,\"\\n      \"],[10,0],[14,0,\"controls inline-form full-width\"],[12],[1,\"\\n        \"],[8,[39,9],null,[[\"@id\",\"@valueProperty\",\"@content\",\"@value\",\"@onChange\",\"@options\"],[\"postTime\",\"value\",[30,0,[\"postTimeOptions\"]],[30,0,[\"searchedTerms\",\"time\",\"when\"]],[28,[37,4],[[30,0],\"onChangeWhenTime\"],null],[28,[37,2],null,[[\"headerAriaLabel\"],[[28,[37,0],[\"search.advanced.post.time.aria_label\"],null]]]]]],null],[1,\"\\n        \"],[8,[39,11],null,[[\"@date\",\"@onChange\",\"@inputId\"],[[30,0,[\"searchedTerms\",\"time\",\"days\"]],[28,[37,4],[[30,0],\"onChangeWhenDate\"],null],\"search-post-date\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"advanced-search-options-below\",\"div\",[28,[37,2],null,[[\"searchedTerms\",\"onChangeSearchedTermField\"],[[30,0,[\"searchedTerms\"]],[30,0,[\"onChangeSearchedTermField\"]]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"details\"],[14,0,\"search-advanced-additional-options\"],[12],[1,\"\\n    \"],[10,\"summary\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"search.advanced.additional_options.label\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"count-group control-group\"],[12],[1,\"\\n\"],[1,\"      \"],[10,1],[14,0,\"control-label\"],[12],[1,[28,[35,0],[\"search.advanced.post.count.label\"],null]],[13],[1,\"\\n      \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n        \"],[8,[39,7],[[24,0,\"input-small\"],[24,1,\"search-min-post-count\"],[16,\"placeholder\",[28,[37,0],[\"search.advanced.post.min.placeholder\"],null]],[16,\"aria-label\",[28,[37,0],[\"search.advanced.post.min.aria_label\"],null]],[4,[38,8],[\"input\",[28,[37,13],[[30,0,[\"onChangeSearchTermMinPostCount\"]]],null]],null]],[[\"@type\",\"@value\"],[\"number\",[28,[37,12],[[30,0,[\"searchedTerms\",\"min_posts\"]]],null]]],null],[1,\"\\n        \"],[1,[28,[35,14],[\"arrows-alt-h\"],null]],[1,\"\\n        \"],[8,[39,7],[[24,0,\"input-small\"],[24,1,\"search-max-post-count\"],[16,\"placeholder\",[28,[37,0],[\"search.advanced.post.max.placeholder\"],null]],[16,\"aria-label\",[28,[37,0],[\"search.advanced.post.max.aria_label\"],null]],[4,[38,8],[\"input\",[28,[37,13],[[30,0,[\"onChangeSearchTermMaxPostCount\"]]],null]],null]],[[\"@type\",\"@value\"],[\"number\",[28,[37,12],[[30,0,[\"searchedTerms\",\"max_posts\"]]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"count-group control-group\"],[12],[1,\"\\n\"],[1,\"      \"],[10,1],[14,0,\"control-label\"],[12],[1,[28,[35,0],[\"search.advanced.views.label\"],null]],[13],[1,\"\\n      \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n        \"],[8,[39,7],[[24,0,\"input-small\"],[24,1,\"search-min-views\"],[16,\"placeholder\",[28,[37,0],[\"search.advanced.min_views.placeholder\"],null]],[16,\"aria-label\",[28,[37,0],[\"search.advanced.min_views.aria_label\"],null]],[4,[38,8],[\"input\",[28,[37,13],[[30,0,[\"onChangeSearchTermMinViews\"]]],null]],null]],[[\"@type\",\"@value\"],[\"number\",[28,[37,12],[[30,0,[\"searchedTerms\",\"min_views\"]]],null]]],null],[1,\"\\n        \"],[1,[28,[35,14],[\"arrows-alt-h\"],null]],[1,\"\\n        \"],[8,[39,7],[[24,0,\"input-small\"],[24,1,\"search-max-views\"],[16,\"placeholder\",[28,[37,0],[\"search.advanced.max_views.placeholder\"],null]],[16,\"aria-label\",[28,[37,0],[\"search.advanced.max_views.aria_label\"],null]],[4,[38,8],[\"input\",[28,[37,13],[[30,0,[\"onChangeSearchTermMaxViews\"]]],null]],null]],[[\"@type\",\"@value\"],[\"number\",[28,[37,12],[[30,0,[\"searchedTerms\",\"max_views\"]]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"site\",\"mobileView\"]],[[[1,\"    \"],[10,0],[14,0,\"second-search-button\"],[12],[1,\"\\n      \"],[8,[39,15],[[24,0,\"btn-primary search-cta\"]],[[\"@action\",\"@icon\",\"@label\",\"@ariaLabel\",\"@disabled\"],[[30,0,[\"search\"]],\"search\",\"search.search_button\",\"search.search_button\",[30,0,[\"searchButtonDisabled\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[],false,[\"i18n\",\"plugin-outlet\",\"hash\",\"search-advanced-category-chooser\",\"action\",\"if\",\"tag-chooser\",\"input\",\"on\",\"combo-box\",\"user-chooser\",\"date-input\",\"readonly\",\"with-event-value\",\"d-icon\",\"d-button\"]]",
  "moduleName": "discourse/components/search-advanced-options.hbs",
  "isStrictMode": false
});